import React from 'react';
import {
  Paper,
  Typography,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box
} from '@mui/material';
import { motion } from 'framer-motion';
import { Question } from '../types';

interface AssessmentQuestionProps {
  question: Question;
  selectedAnswer: number | null;
  onAnswer: (index: number) => void;
  color: string;
}

export const AssessmentQuestion: React.FC<AssessmentQuestionProps> = ({
  question,
  selectedAnswer,
  onAnswer,
  color,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onAnswer(Number(event.target.value));
  };

  return (
    <motion.div
      key={question.question}
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: -20 }}
    >
      <Paper 
        elevation={3}
        className="question-card"
        sx={{ p: 3, mb: 3, borderRadius: 2 }}
      >
        <Box sx={{ mb: 3 }}>
          <Typography 
            variant="h5" 
            gutterBottom
          >
            {question.question}
          </Typography>
          {question.explanation && (
            <Typography 
              variant="body2" 
              color="text.secondary"
              sx={{ 
                mt: 1, 
                fontStyle: 'italic',
                backgroundColor: 'rgba(0, 0, 0, 0.03)',
                p: 1.5,
                borderRadius: 1,
                borderLeft: '4px solid',
                borderColor: color
              }}
            >
              {question.explanation}
            </Typography>
          )}
        </Box>
        
        <FormControl component="fieldset" sx={{ width: '100%' }}>
          <RadioGroup 
            value={selectedAnswer ?? ''} 
            onChange={handleChange}
          >
            {question.options.map((option, index) => (
              <FormControlLabel
                key={index}
                value={index}
                control={
                  <Radio 
                    sx={{ 
                      '&.Mui-checked': {
                        color: color,
                      }
                    }}
                  />
                }
                label={
                  <Typography 
                    variant="body1" 
                    sx={{ 
                      py: 0.5,
                      '&:hover': { color: color }
                    }}
                  >
                    {option?.text}
                  </Typography>
                }
                sx={{ 
                  mb: 1,
                  p: 1,
                  borderRadius: 1,
                  transition: 'background-color 0.2s',
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                  }
                }}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </Paper>
    </motion.div>
  );
};
